export default __webpack_public_path__ + "static/media/60_desktop.8acf162e.jpg";